import PoolsService from './pools/pools.service';
import FarmPoolsService from './farm-pools/farm-pools.service';

export default class BalancerService {
  pools: PoolsService;
  farmPools: FarmPoolsService;

  constructor() {
    this.pools = new PoolsService();
    this.farmPools = new FarmPoolsService();
  }
}

export const balancerService = new BalancerService();
